.button {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  height: var(--control-height);
  padding: 0 var(--space-4);
  border: 1px solid var(--border);
  border-radius: var(--radius-control);
  background: var(--paper);
  color: var(--ink);
  font: var(--t-body);
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  transition:
    background-color var(--dur) var(--ease),
    border-color var(--dur) var(--ease),
    color var(--dur) var(--ease);
}

.button[data-focus-visible] {
  outline: var(--focus-ring);
  outline-offset: var(--focus-offset);
}

.button[data-dense] {
  height: var(--control-height-dense);
  padding: 0 var(--space-3);
}

/* Primary: near-black fill, white text. Hover lightens it a step; pressed is black. */
.button[data-variant='primary'] {
  border-color: var(--brand);
  background: var(--brand);
  color: var(--on-brand);
}

.button[data-variant='primary'][data-hovered] {
  border-color: var(--brand-strong);
  background: var(--brand-strong);
}

.button[data-variant='primary'][data-pressed] {
  border-color: var(--brand-deep);
  background: var(--brand-deep);
}

/* Secondary: white with a hairline; hover and pressed take a light grey. */
.button[data-variant='secondary'][data-hovered] {
  border-color: var(--border-strong);
  background: var(--brand-tint);
}

.button[data-variant='secondary'][data-pressed] {
  background: var(--brand-tint-strong);
}

.button[data-variant='quiet'] {
  padding: 0 var(--space-2);
  border-color: transparent;
  background: transparent;
  color: var(--brand);
}

.button[data-variant='quiet'][data-hovered] {
  text-decoration: underline;
  text-underline-offset: 2px;
}

.button[data-variant='quiet'][data-pressed] {
  background: var(--brand-tint);
}

.button[data-variant='destructive'] {
  border-color: var(--danger);
  color: var(--danger);
}

.button[data-variant='destructive'][data-hovered] {
  background: var(--danger-tint);
}

.button[data-variant='destructive'][data-pressed] {
  background: var(--danger-tint);
}

.button[data-pending] {
  cursor: progress;
}

.button[data-disabled] {
  border-color: var(--rule);
  background: var(--wash);
  color: var(--pencil);
  cursor: not-allowed;
}

.button[data-variant='quiet'][data-disabled] {
  border-color: transparent;
  background: transparent;
}

/* The shortcut tooltip: a small floating layer in ink, like a toast. */
.tooltip {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-float);
  background: var(--night);
  color: var(--on-brand);
  font: var(--t-small);
  box-shadow: var(--shadow-float);
}

.tooltip[data-entering] {
  animation: fade var(--dur) var(--ease);
}

@keyframes fade {
  from {
    opacity: 0;
  }
}

/* Links styled as buttons (buttonLinkProps): no underline, and plain :hover and
   :focus-visible in place of React Aria's data attributes. */
a.button {
  text-decoration: none;
}

a.button:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-offset);
}

a.button[data-variant='primary']:hover {
  border-color: var(--brand-strong);
  background: var(--brand-strong);
}

a.button[data-variant='secondary']:hover {
  border-color: var(--border-strong);
  background: var(--brand-tint);
}

a.button[data-variant='quiet']:hover {
  text-decoration: underline;
  text-underline-offset: 2px;
}
